import { COOKIE_POLICY_URL, PRIVACY_POLICY_URL } from "../../../config";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import "./style.css";
import tsLogo from "./tsLogo.svg";

const fm = getFormattedMessageWithScope("components.PrivacyCookiePolicyFooter");

export const PrivacyCookiePolicyFooter = () => (
    <div className="c-PrivacyCookiePolicyFooter">
        <img
            src={tsLogo}
            alt="TeamSystem"
            className="c-PrivacyCookiePolicyFooter-logo"
        />
        <span className="c-PrivacyCookiePolicyFooter-links">
            <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                rel="noreferrer"
                className="c-PrivacyCookiePolicyFooter-link"
            >
                {fm("privacyPolicy")}
            </a>
            -
            <a
                href={COOKIE_POLICY_URL}
                target="_blank"
                rel="noreferrer"
                className="c-PrivacyCookiePolicyFooter-link"
            >
                {fm("cookiePolicy")}
            </a>
        </span>
    </div>
);
